import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import Button, { ButtonSize, ButtonVariant } from './Button';
function Navbar() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const handleNavigation = (hash) => {
        const element = document.querySelector(hash);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        setIsMobileMenuOpen(false); // Close mobile menu after navigation
    };
    return (_jsxs("div", Object.assign({ style: {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            marginBottom: '67px',
        }, className: "navbar-wrapper" }, { children: [_jsxs("div", Object.assign({ style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    maxWidth: '1200px',
                    padding: '1rem 2rem',
                    position: 'relative',
                }, className: "navbar-container" }, { children: [_jsx("img", { src: "/crownwell-partners-logo-v2-alt.png", alt: "Crownwell Partners Logo", className: "navbar-logo", style: {
                            height: '80px',
                            width: 'auto',
                            zIndex: 10,
                        } }), _jsxs("div", Object.assign({ style: {
                            display: 'flex',
                            gap: '1rem',
                            alignItems: 'center',
                        }, className: "desktop-nav" }, { children: [_jsx(Button, { variant: ButtonVariant.Primary, content: "Strategy", action: () => handleNavigation('#strategy'), size: ButtonSize.Large }), _jsx(Button, { variant: ButtonVariant.Primary, content: "Criteria", action: () => handleNavigation('#criteria'), size: ButtonSize.Large }), _jsx(Button, { variant: ButtonVariant.Primary, content: "Leadership", action: () => handleNavigation('#leadership'), size: ButtonSize.Large }), _jsx(Button, { variant: ButtonVariant.Secondary, content: "Connect", action: () => handleNavigation('#contact'), size: ButtonSize.Large })] })), _jsxs("button", Object.assign({ onClick: () => setIsMobileMenuOpen(!isMobileMenuOpen), style: {
                            display: 'none',
                            flexDirection: 'column',
                            gap: '5px',
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            padding: '8px',
                            zIndex: 10,
                        }, className: "mobile-menu-button" }, { children: [_jsx("span", { style: {
                                    width: '25px',
                                    height: '3px',
                                    backgroundColor: 'white',
                                    transition: 'all 0.3s',
                                    transform: isMobileMenuOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none',
                                } }), _jsx("span", { style: {
                                    width: '25px',
                                    height: '3px',
                                    backgroundColor: 'white',
                                    transition: 'all 0.3s',
                                    opacity: isMobileMenuOpen ? 0 : 1,
                                } }), _jsx("span", { style: {
                                    width: '25px',
                                    height: '3px',
                                    backgroundColor: 'white',
                                    transition: 'all 0.3s',
                                    transform: isMobileMenuOpen ? 'rotate(-45deg) translate(7px, -6px)' : 'none',
                                } })] })), _jsxs("div", Object.assign({ style: {
                            display: isMobileMenuOpen ? 'flex' : 'none',
                            flexDirection: 'column',
                            gap: '1rem',
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            right: 0,
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            padding: '2rem',
                            zIndex: 9,
                            marginTop: '1rem',
                        }, className: "mobile-nav" }, { children: [_jsx(Button, { variant: ButtonVariant.Primary, content: "Strategy", action: () => handleNavigation('#strategy'), size: ButtonSize.Large }), _jsx(Button, { variant: ButtonVariant.Primary, content: "Criteria", action: () => handleNavigation('#criteria'), size: ButtonSize.Large }), _jsx(Button, { variant: ButtonVariant.Primary, content: "Leadership", action: () => handleNavigation('#leadership'), size: ButtonSize.Large }), _jsx(Button, { variant: ButtonVariant.Secondary, content: "Contact", action: () => handleNavigation('#contact'), size: ButtonSize.Large })] }))] })), _jsx("style", { children: `
        @media (max-width: 768px) {
          .desktop-nav {
            display: none !important;
          }
          .mobile-menu-button {
            display: flex !important;
          }
          .navbar-logo {
            height: 60px !important;
            display: block !important;
          }
          .navbar-container {
            padding: 1rem !important;
            justify-content: space-between !important;
          }
          .navbar-wrapper {
            margin-bottom: 2rem !important;
          }
        }
        @media (min-width: 769px) {
          .navbar-container {
            gap: 1rem !important;
          }
          .mobile-nav {
            display: none !important;
          }
          .mobile-menu-button {
            display: none !important;
          }
        }
        @media (max-width: 480px) {
          .navbar-logo {
            height: 50px !important;
          }
        }
      ` })] })));
}
export default Navbar;
